


































































import { Component, Vue } from 'vue-property-decorator';
import { dispatchCheckTemplateProxy, readTemplateProxyResponse } from '@/store/admin/accessors';

@Component
export default class CheckTemplateProxy extends Vue {
  public method: string = 'GET';
  public path: string = '';
  public message: string = '';
  public subscriber: string = '';
  public address: string = '';
  public protocol: string = '';
  public methods = ['GET', 'POST'];
  public dialog = false;

  public response: string = '';
  public statusCode: number | string = '';

  public reset() {
    this.method = 'GET';
    this.path = '';
    this.message = '';
    this.subscriber = '';
    this.address = '';
    this.protocol = '';
  }

  public async submit() {
    await dispatchCheckTemplateProxy(this.$store, {
      method: this.method,
      path: this.path,
      message: this.message || undefined,
      subscriber: this.subscriber || undefined,
      address: this.address || undefined,
      protocol: this.protocol || undefined,
    });
    const response = await readTemplateProxyResponse(this.$store);
    if (response) {
      this.response = response.response;
      this.statusCode = response.status_code;
      this.dialog = true;
    }
  }
}
